import React from 'react';

function FunctionKeysComponent() {
    return <div>FunctionKeysComponent</div>;
}

export default FunctionKeysComponent;
